let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("idTe8")).then(() => parcelRequire('fO9ZU'));